import { Helmet } from 'react-helmet';
import { serializeJsonLd, SiteSchema } from './structuredData';

type SeoTagsProps = {
  canonical: string;
  schema: SiteSchema;
  noindex?: boolean;
  title?: string;
  description?: string;
};

export const SeoTags = ({
  canonical,
  schema,
  noindex = false,
  title,
  description,
}: SeoTagsProps) => (
  <>
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name='description' content={description} />}
      <link rel='canonical' href={canonical} />
      <meta name='robots' content={noindex ? 'noindex,follow' : 'index,follow'} />
      {title && <meta property='og:title' content={title} />}
      {description && <meta property='og:description' content={description} />}
      {title && <meta name='twitter:title' content={title} />}
      {description && <meta name='twitter:description' content={description} />}
    </Helmet>
    <script
      id='site-json-ld'
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: serializeJsonLd(schema) }}
    />
  </>
);
